<template>
  <v-card height="100%">
    <v-toolbar dense color="red accent-2" dark>
      <v-toolbar-title>Solicitações de Troca de Escala</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-list>
        <template v-for="(swap, index) in swaps">
          <v-list-item :key="index">
            <ScaleSwapCard :swap="swap" />
          </v-list-item>
        </template>
        <template v-if="swaps.length == 0">
          <v-container fluid class="d-flex justify-center">
            <span
              class="pa-10"
              style="
                color: #666;
                font-size: 24px;
                background-color: rgba(0, 0, 0, 0.1);
                border-radius: 8px;
              "
              >Nenhuma solicitação pendente.</span
            >
          </v-container>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import ScaleSwapCard from './ScaleSwapCard'
import { mapState } from 'vuex'
export default {
  name: 'ScaleSwapsList',
  components: { ScaleSwapCard },
  data: () => {
    return {}
  },
  computed: {
    ...mapState('coordinator', ['swaps']),
  },
}
</script>
